import TrustpilotTestimonial from "./TrustpilotTestimonial";

export default TrustpilotTestimonial;
